import classNames from 'classnames';
import React, { useContext, useState, useRef, useEffect } from "react";
import axios from "axios";
import { useFlashMessage } from "../context/FlashMessageContext";
//import Select2 from "react-chosen";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { post } from "../services/apiService";
import { useNavigate } from 'react-router-dom';
import FlagIcon from "./FlagIcon";
import DialCodes from '../data/dialCodes.json';
import { FlashMessage } from '../utils/FlashMessage';
import { ToastContainer, toast } from 'react-toastify';


const NewVendorForm = props => {
  const {
    loadingCallback,
    setVendor,
    setWarningMessage,
    state,
    setShowModal,
    setVendorData
  } = props;
  // Gneral Focus Hook
  const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }

    return [htmlElRef, setFocus]
  }
  const [inputRef, setInputFocus] = useFocus();

  const { countryList } = state;
  const [country, setCountry] = useState('');
  const [districtList, setDistrictList] = useState([]);
  const [district, setDistrict] = useState('');
  const [cityList, setCityList] = useState([]);
  const { getFlashMessageStyle, setSuccessFlashMessage, flashMessage, setErrorFlashMessage } = useFlashMessage(); // Retrieve the dispatch function from your state management library
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [showNewVendorForm, setShowNewVendorForm] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [isValid, setIsValid] = useState(true);
  const navigate = useNavigate();
  const page = 1;
  const perPage = 20;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (selectedCustomer && selectedCustomer.country) {
      setCountry(selectedCustomer.country);
      getDistrictList(selectedCustomer.country);
    } else {
      getDistrictList(country);
    }

  }, [country, selectedCustomer]);

  const getDistrictList = (country) => {
    post("get-district-by-country", { country_id: country }, token)
      .then((response) => {
        if (response.success) {
          setDistrictList(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCityList = (district) => {
    setDistrict(district);
    post("get-cities-by-district", { district_id: district }, token)
      .then((response) => {
        if (response.success) {
          setCityList(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDialCodeByCountryCode = (code) => {
    const country = DialCodes.find((item) => item.code === code);
    return country ? country.dial_code : '';
  };










  const handleValidation = (formData) => {
    const errors = {};
    let validate = true
    // if (formData.proprietor_email === '') {
    //   errors.proprietor_email = 'Email is required.';
    //   setIsValid(false);
    //   validate = false;
    // }
    if (formData.proprietor_email !== '') {
      if (formData.proprietor_email.indexOf('@') === -1) {
        errors.proprietor_email = 'Email is not valid.';
        setIsValid(false);
        validate = false;
      } else {
        //Email address cannot have only numbers before @
        const emailParts = formData.proprietor_email.split('@');
        if (emailParts[0].match(/^[0-9]+$/) !== null) {
          errors.proprietor_email = 'Email is not valid.';
          setIsValid(false);
          validate = false;
        }
      }

    }
    if (formData.vendor_name === '') {
      errors.vendor_name = 'Vendor name is required.';
      setIsValid(false);
      validate = false;

    }
    //proprietor_name
    if (formData.proprietor_name === '') {
      errors.proprietor_name = 'Proprietor name is required.';
      setIsValid(false);
      validate = false;
    }

    if (formData.vendor_phone === '') {
      errors.vendor_phone = 'Phone Number is required.';
      setIsValid(false);
      validate = false;
    }
    setFormErrors(errors);
    if (!validate) {
      // setErrorFlashMessage('Please fill all the required fields.');
      FlashMessage('Please fill all the required fields.','error');
    }

    return validate;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const formObject = {};

    formData.forEach((value, key) => {
      formObject[key] = value;
    });
    if (!selectedCustomer) {
      formObject.vendor_id = 0;
    }
    if (handleValidation(formObject)) {
      // console.log("============");
      // console.log(isValid);
      // console.log(formObject);
      // console.log(formErrors);
      //if (isValid) {
      const vendorData = {
        name: formObject.vendor_name ? formObject.vendor_name : null,
        email: formObject.proprietor_email ? formObject.proprietor_email : null,
        country_code: formObject.country_code ? formObject.country_code : null,
        mobile_number: formObject.vendor_phone ? formObject.vendor_phone : null,
        address: formObject.vendor_address ? formObject.vendor_address : null,
        country: formObject.country_id ? Number(formObject.country_id) : null,
        district: formObject.district_id ? Number(formObject.district_id) : null,
        city: formObject.city_id ? Number(formObject.city_id) : null,
        zipcode: formObject.vendor_zip ? Number(formObject.vendor_zip) : null,
        proprietor_name: formObject?.proprietor_name ? formObject.proprietor_name : 'squadinnovators'
      };
      // console.log("============");
      // console.log(customerData);


      createVendor(vendorData);



    } else {
      console.error('Form validation failed.');
    }

  };

  const createVendor = (formData) => {
    loadingCallback(true);
    // setVendorData(formData);
    // setVendor(formData);
    post("save-vendor", formData, token)
      .then((response) => {
        loadingCallback(false);
        if (response.status === 200) {
          setVendor(response.data);
          setVendorData(response.data);
          // setSuccessFlashMessage('Vendor saved successfully');
          FlashMessage('Vendor saved successfully','success');
          //setShowNewVendorForm(false);
        } else {
          console.log("Vendor insertion failed");

          setWarningMessage(true);
          const timer = setTimeout(() => {
            setWarningMessage(false);
          }, 3000);
          return () => clearTimeout(timer);
        }
      })
      .catch((error) => {
        loadingCallback(false);
        if (error?.response?.status === 401) {
          localStorage.setItem('token', '');
          // Clear session and local storage
          localStorage.setItem('isPinVerify', false);

          navigate('/login');
        }
        console.log(error);
      });
  }


  const handleErrorInputChange = (fieldName, value) => {
    if (value !== '') {
      //formErrors[fieldName] = null;
      // unset formErrors by fieldName
      const updatedFormErrors = { ...formErrors };
      delete updatedFormErrors[fieldName];
      setFormErrors(updatedFormErrors);
    }

  }


  return (
    <form
      method="get"
      className="col-sm-12"
      data-autosubmit="false"
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <ToastContainer />
      <div className='flex gap-3'>
        {/* <div className="mb-3 flex-1">
          <input
            type="text"
            id="proprietor_name"
            name="proprietor_name"
            className={classNames(
              'form-control',
              'rounded-[15px]',
              'p-3',
              'bg-white'

            )}
            placeholder="Proprietor Name"
            onChange={(e) => {
              handleErrorInputChange('proprietor_name', e.target.value)
            }}
          />
          {formErrors && formErrors.proprietor_name ? <p className="error-message text-red-500">{formErrors.proprietor_name}</p> : null}
        </div> */}
        <div className="mb-3 flex-1">
          <input
            type="text"
            id="proprietor_email"
            name="proprietor_email"
            className={classNames(
              'form-control',
              'rounded-[15px]',
              'p-3',
              'bg-white'

            )}
            placeholder="Proprietor Email"
            //ref={inputRef}
            onChange={(e) => {
              //delete formErrors.vendor_email;
              handleErrorInputChange('proprietor_email', e.target.value)
            }}
          />
          {formErrors && formErrors.proprietor_email ? <p className="error-message text-red-500">{formErrors.proprietor_email}</p> : null}
        </div>
      </div>
      <div className="mb-3">

        <input
          type="text"
          id="vendor_name"
          name="vendor_name"
          className={classNames(
            'form-control',
            'rounded-[15px]',
            'p-3',
            'bg-white'

          )}
          placeholder="Vendor Name"
          onChange={(e) => {
            handleErrorInputChange('vendor_name', e.target.value)
          }}
        />
        {formErrors && formErrors.vendor_name ? <p className="error-message text-red-500">{formErrors.vendor_name}</p> : null}
      </div>
      <div className="mb-3 flex ">
        {/* <div className="flex-grow w-2/4">
          <select
            id="country_code"
            name="country_code"
            className={classNames(
              'rounded-[15px]',
              'p-3',
              'bg-white',
              'mr-2'
            )}
            style={{ border: "1px solid #ccc" }}
          >

            <option value="">Select</option>
            {countryList.map((country) => (
              <option key={country.id} className="text-[14px]" value={getDialCodeByCountryCode(country.code)}>
                <FlagIcon countryCode={country.code} />{getDialCodeByCountryCode(country.code)}
              </option>
            ))}
          </select>
        </div> */}
        <div className="flex-grow w-4/5">
        <input
          type="text"
          id="vendor_phone"
          name="vendor_phone"
          className={classNames(
            'form-control',
            'rounded-[15px]',
            'p-3',
            'bg-white'

          )}
          placeholder=" Phone Number"
          onChange={(e) => {
            handleErrorInputChange('vendor_phone', e.target.value)
          }}
        />
        {formErrors && formErrors.vendor_phone ? <p className="error-message text-red-500">{formErrors.vendor_phone}</p> : null}
        </div>
      </div>
      {/* {country select box} */}
      {/* <div className="mb-3">
        <select
          id="country_id"
          name="country_id"
          className={classNames(
            'w-full',
            'rounded-[15px]',
            'p-3',
            'bg-white'
          )}
          style={{ border: "1px solid #ccc" }}
          onChange={e => setCountry(e.target.value)}
        >
          <option value="">Select Country</option>
          {countryList.map((country) => (
            <option key={country.id} value={country.id}>
              {country.name}
            </option>
          ))}
        </select>
      </div> */}
      <div className='flex gap-3'>

        <div className="mb-3 flex-1">
          <input
            type="text"
            id="vendor_address"
            name="vendor_address"
            className={classNames(
              'form-control',
              'rounded-[15px]',
              'p-3',
              'bg-white'

            )}
            placeholder="Vendor Address"
          />
        </div>
        {/* <div className="mb-3 flex-1">
          <select
            id="district_id"
            name="district_id"
            className={classNames(
              'w-full',
              'rounded-[15px]',
              'p-3',
              'bg-white'
            )}
            style={{ border: "1px solid #ccc" }}
            onChange={e => getCityList(e.target.value)}
          >
            <option value="">Branch District</option>
            {districtList.map((district) => (
              <option key={district.id} value={district.id}>
                {district.name}
              </option>
            ))}
          </select>
        </div> */}
      </div>
      <div className="flex gap-3 mb-3">

        {/* <div className='flex-1'>
          <select
            id="city_id"
            name="city_id"
            className={classNames(
              'w-full',
              'rounded-[15px]',
              'p-3',
              'bg-white'
            )}
            style={{ border: "1px solid #ccc" }}
          >
            <option value="">Select City</option>
            {cityList.map((city) => (
              <option key={city.id} value={city.id}>
                {city.name}
              </option>
            ))}
          </select>
        </div> */}
       {/* <div className='flex-1'>
        <input
            type="text"
            id="vendor_zip"
            name="vendor_zip"
            className={classNames(
              'form-control',
              'rounded-[15px]',
              'p-3',
              'bg-white',

            )}
            placeholder="Zip Code"
          />
       </div> */}
      </div>






      <div className="button-disabled">
        <button
          type="submit"
          className="cursor-pointer w-full bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
        > Add New Vendor
        </button>
      </div>

    </form>
  );
};

export default NewVendorForm;
